module.exports = "/_next/static/images/5ed5e05d9746041bc32cbb606fec1a8b-man-looking-up-smiling-lg@1x.jpg.webp";